export function extractErrorMessage(error) {
    // Axios error with response
    if (error?.response) {
        // Try to get specific message from the response body
        if (error.response?.status === 429) {
            return 'Too many requests. Please try again later.';
        } else if (error?.response?.data?.message) {
            return error?.response?.data?.message;
        }
        if (typeof error?.response?.data === 'string') {
            return error?.response?.data;
        }
        return `Request failed with status ${error?.response?.status}`;
    }

    // Axios error with request but no response
    if (error?.request) {
        return 'No response received from server.';
    }

    // Any other errors
    return error?.message || 'An unknown error occurred.';
}